import "@/App.css";
import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "@/components/Layout";
import { Toaster } from "sonner";

const LandingPage = lazy(() => import("@/pages/LandingPage"));
const FindJobsPage = lazy(() => import("@/pages/FindJobsPage"));
const JobDetailPage = lazy(() => import("@/pages/JobDetailPage"));
const TrackJobsPage = lazy(() => import("@/pages/TrackJobsPage"));
const ResumePage = lazy(() => import("@/pages/ResumePage"));
const CoverLetterPage = lazy(() => import("@/pages/CoverLetterPage"));
const ToolsPage = lazy(() => import("@/pages/ToolsPage"));
const PricingPage = lazy(() => import("@/pages/PricingPage"));
const AccountPage = lazy(() => import("@/pages/AccountPage"));
const TermsPage = lazy(() => import("@/pages/TermsPage"));
const PrivacyPage = lazy(() => import("@/pages/PrivacyPage"));
const AdminMetricsPage = lazy(() => import("@/pages/AdminMetricsPage"));

function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, search]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Toaster position="top-right" richColors />
      <Suspense fallback={null}>
        <Routes>
          <Route path="/admin" element={<AdminMetricsPage />} />
          <Route element={<Layout />}>
            <Route path="/" element={<LandingPage />} />
            <Route path="/jobs" element={<FindJobsPage />} />
            <Route path="/jobs/:id" element={<JobDetailPage />} />
            <Route path="/track" element={<TrackJobsPage />} />
            <Route path="/tools" element={<ToolsPage />} />
            <Route path="/resume" element={<ResumePage />} />
            <Route path="/cover-letter" element={<CoverLetterPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/account" element={<AccountPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
